<template>
  <div class="sidebar-top">
    <div class="time">
      <img class="time-icon" :src="icon" alt />
      {{ currentTime }}
    </div>
    <div class="temperature-humidity">
      <div class="humidity-ring">
        <div class="humidity-animation">
          <div class="humidity-icon"></div>
          <div class="humidity-title">PM2.5指数 / 甲醛</div>
          <div class="humidity-value">
            {{
              componentCallsData &&
              componentCallsData.data &&
              componentCallsData.data.data
                ? componentCallsData.data.data.pm25
                : null
            }}
            /
            {{
              componentCallsData &&
              componentCallsData.data &&
              componentCallsData.data.data
                ? componentCallsData.data.data.cho
                : null
            }}
          </div>
        </div>
      </div>
      <div class="temperature-ring">
        <div class="temperature-animation">
          <div class="temperature-icon"></div>
          <div class="temperature-title">气温 / 湿度</div>
          <div class="temperature-value">
            {{
              componentCallsData &&
              componentCallsData.data &&
              componentCallsData.data.data
                ? componentCallsData.data.data.temperature
                : null
            }}
            <span style="font-size: 10px">°C</span>
            /
            {{
              componentCallsData &&
              componentCallsData.data &&
              componentCallsData.data.data
                ? componentCallsData.data.data.humidity
                : null
            }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { mapState } from "vuex";
export default {
  data() {
    return {
      timer: null,
      currentTime: "",
      icon: require("./../../../src/assets/index/cloud.png"),
      humidity: "38.00",
      temperature: 15,
    };
  },
  computed: {
    ...mapState(["componentCallsData"]),
  },
  created() {
    this.startTimer();
  },
  beforeDestroy() {
    if (!this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  },
  methods: {
    startTimer() {
      if (!this.timer) {
        this.timer = setInterval(() => {
          const now = moment();
          const datetime = now.format("YYYY-MM-DD HH:mm");
          this.currentTime = `${datetime}`;
        }, 1000);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.sidebar-top {
  text-align: right;
  .time {
    height: 30px;
    z-index: 0;
    transform: rotate(0deg);
    opacity: 1;
    pointer-events: none;
    color: #fff;
    font-size: 18px;
    .time-icon {
      width: 18px;
      height: 18px;
    }
  }

  .temperature-humidity {
    .humidity-ring,
    .temperature-ring {
      width: 274px;
      height: 67px;
      position: relative;
      pointer-events: auto;
      image-rendering: -webkit-optimize-contrast;
      background-repeat: no-repeat;
      background-size: 100% 100%;
      background-image: url("./../../../src/assets/index/ring.png");
      -webkit-mask-image: none;
      -webkit-mask-repeat: initial;
      -webkit-mask-size: initial;
      background-color: initial;
      border-radius: 0px;
      cursor: pointer;
      .humidity-animation,
      .temperature-animation {
        width: 104px;
        height: 74px;
        position: absolute;
        left: -19px;
        top: -3px;
        opacity: 1;
        background-image: url("./../../../src/assets/index/animation.png");
        background-size: contain;
        background-repeat: no-repeat;
        background-position: center center;
        .humidity-icon,
        .temperature-icon {
          width: 34px;
          height: 34px;
          position: absolute;
          pointer-events: auto;
          image-rendering: -webkit-optimize-contrast;
          -webkit-mask-repeat: no-repeat;
          -webkit-mask-size: 100% 100%;
          -webkit-mask-image: url(./../../../src/assets/index/water.png);
          background: rgb(70, 249, 249);
          border-radius: 0px;
          cursor: pointer;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
        }
        .temperature-icon {
          -webkit-mask-image: url(./../../../src/assets/index/temperature.png);
        }
        .humidity-title,
        .temperature-title {
          color: rgb(121, 218, 255);
          position: absolute;
          left: 90px;
          width: 100%;
          top: 15px;
          font-size: 12px;
        }
        .temperature-title {
          text-align: center;
        }
        .humidity-value,
        .temperature-value {
          color: #fff;
          position: absolute;
          width: 100%;
          left: 80px;
          bottom: 15px;
          font-weight: bold;
          letter-spacing: 1px;
          font-size: 16px;
        }
        .temperature-value {
          left: 90px;
          width: max-content;
        }
      }
    }
    .temperature-ring {
      left: 225px;
      top: -67px;
    }
  }
}
</style>
